<template>
  <div>
    <v-container fluid pa-0>
      <v-row>
        <!-- When to exit out of a position -->
        <v-col cols="12" mb-2>
          <helpers-section-sub-header
            >Use Volatility Adjusted Trade Sizing:</helpers-section-sub-header
          >

          <v-row>
            <v-col cols="12" sm="6" md="4" xl="3" d-flex align="end" />
            <v-col cols="12" sm="6" md="4" xl="3" d-flex align="end">
              <v-row />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  computed: {
    ...mapFields({
      criteria: 'app.whaleTraderCriteria'
    })
  }
}
</script>
